import { AddedFrom, Contractor } from "@/api/williams/contractors";
import { DateTime } from "@/util";

import styles from "./Dashboard.tsx.module.css";

export function ContractorDetails({ contractor }: { contractor: Contractor }) {
  const fields = [
    { label: "Contractor Name", value: contractor.name },
    { label: "Address line 1", value: contractor.addressLine1 },
    { label: "Address line 2", value: contractor.addressLine2 },
    { label: "Address line 3", value: contractor.addressLine3 },
    { label: "Phone number", value: contractor.phoneNumber },
    { label: "Email address", value: contractor.emailAddress },
    { label: "Added from", value: contractor.addedFrom === AddedFrom.Waypoint ? "Waypoint" : "Unknown" },
    { label: "Added date", value: DateTime.getLocalDate(contractor.creationDate) },
    { label: "Last used date", value: DateTime.getLocalDate(contractor.lastUsedDate) ?? "Never" },
    { label: "Shop or field", value: contractor.shopOrField },
    { label: "Welding specialist", value: contractor.weldingSpecialist?.name },
    { label: "Region(s)", value: contractor.regions?.map((x) => x.name).join(", ") },
  ];

  const visibleFields = fields.filter((x) => x.value);

  return (
    <div className="d-lg-flex flex-wrap justify-content-between">
      {/* First column */}
      <ul className={styles.fieldList}>
        {visibleFields.slice(0, 6).map((field, index) => (
          <li key={index}>
            <label>{field.label}</label>
            <span>{field.value}</span>
          </li>
        ))}
      </ul>

      {/* Second column */}
      <ul className={styles.fieldList}>
        {visibleFields.slice(6, 12).map((field, index) => (
          <li key={index}>
            <label>{field.label}</label>
            <span>{field.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
